import React from "react";
import GoogleTranslator from "../components/GoogleTranslator";

const DemoPage = () => {
  return <GoogleTranslator />;
};

export default DemoPage;
